/* tslint:disable */
/* eslint-disable */
/**
 * Geckosoft.Pim.Api | rt-v0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductNotificationPayloadProductsInner } from './ProductNotificationPayloadProductsInner';
import {
    ProductNotificationPayloadProductsInnerFromJSON,
    ProductNotificationPayloadProductsInnerFromJSONTyped,
    ProductNotificationPayloadProductsInnerToJSON,
    ProductNotificationPayloadProductsInnerToJSONTyped,
} from './ProductNotificationPayloadProductsInner';

/**
 * A creation, update or deletion of products of the company.
 * @export
 * @interface ProductNotificationPayload
 */
export interface ProductNotificationPayload {
    /**
     * What happened to the products.
     * @type {ProductNotificationPayloadOperationEnum}
     * @memberof ProductNotificationPayload
     */
    operation: ProductNotificationPayloadOperationEnum;
    /**
     * The products that were created, updated or deleted.
     * @type {Array<ProductNotificationPayloadProductsInner>}
     * @memberof ProductNotificationPayload
     */
    products: Array<ProductNotificationPayloadProductsInner>;
}


/**
 * @export
 */
export const ProductNotificationPayloadOperationEnum = {
    Creation: 'creation',
    Update: 'update',
    Deletion: 'deletion'
} as const;
export type ProductNotificationPayloadOperationEnum = typeof ProductNotificationPayloadOperationEnum[keyof typeof ProductNotificationPayloadOperationEnum];


/**
 * Check if a given object implements the ProductNotificationPayload interface.
 */
export function instanceOfProductNotificationPayload(value: object): value is ProductNotificationPayload {
    if (!('operation' in value) || value['operation'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function ProductNotificationPayloadFromJSON(json: any): ProductNotificationPayload {
    return ProductNotificationPayloadFromJSONTyped(json, false);
}

export function ProductNotificationPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductNotificationPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'operation': json['operation'],
        'products': ((json['products'] as Array<any>).map(ProductNotificationPayloadProductsInnerFromJSON)),
    };
}

export function ProductNotificationPayloadToJSON(json: any): ProductNotificationPayload {
    return ProductNotificationPayloadToJSONTyped(json, false);
}

export function ProductNotificationPayloadToJSONTyped(value?: ProductNotificationPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation': value['operation'],
        'products': ((value['products'] as Array<any>).map(ProductNotificationPayloadProductsInnerToJSON)),
    };
}

